export * from './pipes.module';
